export * from './pipes.module';
